import { Link } from 'react-router-dom'
import Button from "./Button";

const IconButton = (props) => {
  const {
    size,
    onClick,
    link,
    externalLink,
    targetBlank,
    loading,
    active,
    icon,
    type,
    disabled,
    buttonType,
    title,
    extraClass,
    extraClassContainer,
    forceColor,
    cypress,
    tooltip,
  } = props

  const renderContent = () => (
    <div className={'relative group ' + extraClassContainer}>
      <button
        type={type && !disabled ? type : 'button'}
        data-cy={'button-' + cypress}
        className={
          buttonType +
          ' ' +
          size +
          ' ' +
          extraClass +
          (loading ? ' loading' : '') +
          (active ? ' active' : '') +
          (disabled ? ' disabled' : '')
        }
        onClick={!disabled && onClick ? onClick : null}
        title={title}
      >
        <i className={icon + ' ' + forceColor} />

        <div className='loader'></div>
      </button>
      {tooltip ? (
        <div className='pointer-events-none group-hover:opacity-100 opacity-0 transition-opacity duration-200 absolute -top-24 -translate-x-1/2 left-1/2 text-xs leading-xs whitespace-nowrap px-8 py-2 bg-greyLight4 text-white rounded-8'>
          {tooltip}
        </div>
      ) : null}
    </div>
  )

  if (externalLink) {
    return (
      <a
        href={externalLink}
        target={targetBlank ? '_blank' : ''}
        className='button-link'
        rel='noreferrer'
      >
        {renderContent()}
      </a>
    )
  } else if (link) {
    return (
      <Link to={link} className='button-link'>
        {renderContent()}
      </Link>
    )
  }
  return renderContent()
}

export const PrimaryIconButton = (props) => (
  <IconButton {...props} buttonType='primary-icon-button' />
)
export const SecondaryIconButton = (props) => (
  <IconButton {...props} buttonType='secondary-icon-button' />
)
export const TertiaryIconButton = (props) => (
  <IconButton {...props} buttonType='tertiary-icon-button' />
)
export const ErrorIconButton = (props) => (
  <IconButton {...props} buttonType='error-icon-button' />
)
export const DangerIconButton = (props) => (
  <IconButton {...props} buttonType='danger-icon-button' />
)

IconButton.defaultProps = {
  buttonType: 'primary-button',
  disabled: false,
  title: '',
  extraClass: '',
}

export default IconButton
